import { Component } from '@angular/core';
import { ClientResolverBase } from '../classes/client-resolver-base.class';

@Component({
  selector: 'app-resolver-custom-widget-layout',
  template: `<ng-template #layoutView></ng-template>`,
})
export class ClientResolverCustomWidgetLayoutComponent extends ClientResolverBase {
  protected getLayoutType(): 'custom-widget' {
    return 'custom-widget';
  }
}
